import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    rowGap: theme.spacings.xs,
  },
  inputRow: {
    borderWidth: 1,
    borderRadius: theme.spacings.lg,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: theme.spacings.md,
    overflow: 'hidden',
  },
  textInput: {
    flex: 1,
    padding: theme.spacings.md,
    fontSize: theme.fontSizes.lg,
    fontWeight: '500',
  },
  errorText: {
    color: theme.colors.red,
    fontSize: theme.fontSizes.base,
    paddingLeft: theme.spacings.xs,
  },
});
